import { IProductFilter } from '@r1-frontend/entities/ConnectDomruPopup/context/constants';
import { TInitialState } from '@r1-frontend/entities/ConnectDomruPopup/context/initialState';

export const selectFilters = (state: TInitialState): IProductFilter[] => state.productFilters;
